import { Component } from 'react';

/* línkè · 全局错误兜底
   React 渲染崩了不显示空白，而是显示金色 ✦ + 错误信息 + 刷新按钮
   方便铃截图给哥哥定位 bug */

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // 同时打到 console 方便 devtools 看
    console.error('[línkè ErrorBoundary]', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, info: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error) || '未知错误';
    const stack = this.state.info?.componentStack || this.state.error?.stack || '';
    return (
      <div style={ebOverlayStyle}>
        <div style={ebPanelStyle}>
          <div style={ebStarStyle}>✦</div>
          <div style={ebTitleStyle}>这里出了点问题</div>
          <div style={ebMsgStyle}>{msg}</div>
          {stack && (
            <details style={ebDetailsStyle}>
              <summary style={ebSummaryStyle}>展开技术细节（截图给哥哥看）</summary>
              <pre style={ebStackStyle}>{stack}</pre>
            </details>
          )}
          <div style={ebActionsStyle}>
            <button onClick={this.handleReset} style={ebBtnStyle}>
              再试一次
            </button>
            <button onClick={this.handleReload} style={ebBtnPrimaryStyle}>
              刷新整页
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const ebOverlayStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  background: 'radial-gradient(ellipse at top, rgba(20, 16, 40, 0.9), rgba(8, 6, 18, 0.98))',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
};

const ebPanelStyle = {
  maxWidth: '480px',
  width: '100%',
  padding: '32px 24px',
  background: 'linear-gradient(180deg, rgba(28, 22, 56, 0.96), rgba(18, 14, 42, 0.96))',
  border: '1px solid color-mix(in srgb, var(--gold) 40%, transparent)',
  borderRadius: '16px',
  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5), 0 0 28px color-mix(in srgb, var(--gold) 12%, transparent)',
  color: '#e6e0d0',
  fontFamily: 'system-ui, -apple-system, sans-serif',
};

const ebStarStyle = {
  fontSize: '28px',
  color: '#D9B86A',
  textAlign: 'center',
  textShadow: '0 0 12px color-mix(in srgb, var(--gold) 55.0%, transparent)',
  marginBottom: '12px',
};

const ebTitleStyle = {
  textAlign: 'center',
  fontSize: '18px',
  letterSpacing: '0.18em',
  color: '#D9B86A',
  marginBottom: '16px',
};

const ebMsgStyle = {
  fontSize: '13.5px',
  lineHeight: 1.6,
  color: '#c0b8a8',
  background: 'rgba(0, 0, 0, 0.3)',
  border: '1px solid color-mix(in srgb, var(--gold) 18%, transparent)',
  borderRadius: '8px',
  padding: '12px 14px',
  marginBottom: '14px',
  wordBreak: 'break-word',
};

const ebDetailsStyle = {
  marginBottom: '18px',
  fontSize: '12px',
};

const ebSummaryStyle = {
  cursor: 'pointer',
  color: 'color-mix(in srgb, var(--gold) 70%, transparent)',
  fontStyle: 'italic',
  padding: '4px 0',
};

const ebStackStyle = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontSize: '11px',
  lineHeight: 1.5,
  color: '#8a8275',
  background: 'rgba(0, 0, 0, 0.4)',
  border: '1px solid color-mix(in srgb, var(--gold) 10%, transparent)',
  borderRadius: '6px',
  padding: '10px',
  marginTop: '8px',
  maxHeight: '220px',
  overflowY: 'auto',
  fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
};

const ebActionsStyle = {
  display: 'flex',
  gap: '10px',
  justifyContent: 'center',
};

const ebBtnStyle = {
  padding: '8px 18px',
  border: '1px solid color-mix(in srgb, var(--gold) 30%, transparent)',
  borderRadius: '999px',
  background: 'transparent',
  color: '#D9B86A',
  fontSize: '12.5px',
  letterSpacing: '0.12em',
  cursor: 'pointer',
};

const ebBtnPrimaryStyle = {
  ...ebBtnStyle,
  background: 'color-mix(in srgb, var(--gold) 12%, transparent)',
  borderColor: '#D9B86A',
};
